module.exports = __webpack_public_path__ + "static/media/lease3_img2.5432d922.jpg";